import { Component } from '@angular/core';

import { Register } from '../../shared';


@Register({
  name: 'print',
  title: 'igo.print',
  icon: 'print'
})
@Component({
  selector: 'igo-print-tool',
  template: require('./print-tool.component.html'),
  styles: [require('./print-tool.component.styl')]
})
export class PrintToolComponent {

  constructor() { }

}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/lib/tool/tools/print-tool/print-tool.component.ts